import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IGetDestinatariosResponse } from './destinatario.model';

@Injectable({
  providedIn: 'root'
})
export class DestinatarioService {

  constructor(private http: HttpClient) {}
    
      public getDestinatarios(): Observable<IGetDestinatariosResponse> {
        const url = `${environment.baseURL}Destinatario/GetDestinatarios`;
        return this.http.get<IGetDestinatariosResponse>(url);
      }

      public patchFilaDestinatario(pkDtnr: number, flFilaJnla: boolean): Observable<any> {
        const url = `${environment.baseURL}Destinatario/PatchFilaDestinatario?PK_DTNR=${pkDtnr}&FL_FILA_JNLA=${flFilaJnla}`;
        return this.http.patch<any>(url, {});
      }
}
